import React from 'react';

import propTypes from 'propTypes';
import ApiClient from 'api/ApiClient';
import { signout as signoutPath } from 'apps/account/paths';

export default class LogOutLink extends React.Component {
  static defaultProps = {
    element: 'a',
  };

  static propTypes = {
    className: propTypes.string,
    onClick: propTypes.func,
  };

  handleClick = () => {
    this.props.onClick && this.props.onClick();
    ApiClient.makeRequest(signoutPath(), { method: 'delete' }).then(() => {
      analytics.track('User Logged Out');
      setTimeout(() => {
        window.location.assign('/');
      }, 200);
    });
  };

  render() {
    const { children, className } = this.props;
    const Element = this.props.element;
    return (
      <Element className={className} onClick={this.handleClick}>
        {children}
      </Element>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/common/components/LogOutLink.js